// extracted by mini-css-extract-plugin
module.exports = {"pic":"congrats_pic__NVxGY","ok":"congrats_ok__la6QW","centerBtn":"congrats_centerBtn__3xFl3"};